import { ColumnState } from 'ag-grid-community';
import { create } from 'zustand';
import { defaultMST3010_R01Dto, MST3010_R01Dto } from './Dto_MST3010_R01';

export interface MST3010_R01Filter {
	workplaceNm: string;
}

export interface Store_MST3010_R01 {
	// 검색 조건 (공정명만)
	MST3010_R01Filter: MST3010_R01Filter;
	MST3010_R01PastFilter: MST3010_R01Filter;
	setMST3010_R01Filter: (filter: Partial<MST3010_R01Filter>) => void;
	setMST3010_R01PastFilter: (filter: Partial<MST3010_R01Filter>) => void;

	MST3010_R01List: MST3010_R01Dto[];
	setMST3010_R01List: (list: MST3010_R01Dto[]) => void;
	removeMST3010_R01: (workplaceCd: string) => void;

	selectedMST3010_R01: MST3010_R01Dto | undefined;
	setSelectedMST3010_R01: (selectedMST3010_R01: MST3010_R01Dto | undefined) => void;
	initSelectedMST3010_R01: () => void;

	editMST3010_R01: MST3010_R01Dto;
	setEditMST3010_R01: (data: MST3010_R01Dto) => void;

	columnState: ColumnState[] | null;
	setColumnState: (state: ColumnState[] | null) => void;

	scrollTop: number | null;
	setScrollTop: (top: number | null) => void;

	allCount: number;					setAllCount: (allCount: number) => void;

	initData: () => void;
}

export const defaultMST3010_R01Filter : MST3010_R01Filter = {
	workplaceNm: ''
};

export const useMST3010_R01Store = create<Store_MST3010_R01>((set) => ({
	// 검색 조건 (공정명만)
	MST3010_R01Filter: defaultMST3010_R01Filter,
	MST3010_R01PastFilter: defaultMST3010_R01Filter,
	setMST3010_R01Filter: (filter: Partial<MST3010_R01Filter>) => set((state) => ({ MST3010_R01Filter: { ...state.MST3010_R01Filter, ...filter } })),
	setMST3010_R01PastFilter: (filter: Partial<MST3010_R01Filter>) => set((state) => ({ MST3010_R01PastFilter: { ...state.MST3010_R01PastFilter, ...filter } })),

	MST3010_R01List: [],
	setMST3010_R01List: (list: MST3010_R01Dto[]) => set((state) => {
		return {
			...state,
			MST3010_R01List: list
		}
	}),
	removeMST3010_R01: (workplaceCd: string) => set((state) => {
		return {
			...state,
			MST3010_R01List: [...state.MST3010_R01List].filter(value => value.workplaceCd !== workplaceCd)
		}
	}),

	selectedMST3010_R01: undefined,
	setSelectedMST3010_R01: (selectedMST3010_R01: MST3010_R01Dto | undefined) => set((state) => {
		return {
			...state,
			selectedMST3010_R01 : selectedMST3010_R01,
		}
	}),
	initSelectedMST3010_R01: () => set({ selectedMST3010_R01: undefined, editMST3010_R01: defaultMST3010_R01Dto }),
	
	editMST3010_R01: defaultMST3010_R01Dto,
	setEditMST3010_R01: (data: MST3010_R01Dto) => set((state) => {
		return {
			...state,
			editMST3010_R01: data
		}
	}),

	columnState: null,
	setColumnState: (state: ColumnState[] | null) => set({ columnState: state }),

	scrollTop: null,
	setScrollTop: (top: number | null) => set({ scrollTop: top }),

	allCount: 0,
	setAllCount: (allCount: number) => set({ allCount }),

	initData: () => set((state) => ({
		...state,
		MST3010_R01Filter: defaultMST3010_R01Filter,
		MST3010_R01PastFilter: defaultMST3010_R01Filter,
		MST3010_R01List: [],
		selectedMST3010_R01: undefined,
		editMST3010_R01: { ...defaultMST3010_R01Dto },
		columnState: null,
		allCount: 0,
		scrollTop: null,
	}))
})); 